/* eslint-disable no-template-curly-in-string */
// Definizione dei passaggi del wizard di onboarding. Ogni step ha:
//  - bot:     messaggio del coach (può contenere \n e bullet)
//  - options: array di scelte cliccabili, ognuna porta a un altro step o esegue un'azione:
//             { label, next?: stepKey, navigate?: pathname, end?: boolean }
//  - input:   se true, mostra un campo libero (non usato in MVP statico)

export const FLOW_START = "welcome";

export const FLOW_STEPS = {
  welcome: {
    bot:
      "Ciao, sono Coach Bruno! Sono qui per guidarti passo-passo dentro Tabellone Facile. Da dove vuoi iniziare?",
    options: [
      { label: "Primi passi sulla piattaforma", next: "first_steps" },
      { label: "Configurare il mio Circolo", next: "venue_setup" },
      { label: "Creare il mio primo torneo", next: "create_tournament" },
      { label: "Importare giocatori da Excel", next: "import_players" },
      { label: "Generare il tabellone", next: "generate_bracket" },
      { label: "Programmare gli incontri", next: "schedule_matches" },
      { label: "Inserire risultati", next: "record_results" },
      { label: "Esportare PDF", next: "export_pdf" },
      { label: "Domande sul Regolamento FITP", next: "faq_fitp" },
      { label: "Contattaci", next: "contact_us" },
    ],
  },

  // ─── CONTATTI ───
  contact_us: {
    bot:
      "Sono qui per aiutarti! Se hai bisogno di supporto, puoi contattarci direttamente:\n\n• EMAIL: info@tabellonefacile.net\n• TELEFONO / WHATSAPP: +39 376 289 1321\n• FACEBOOK: cerca 'Tabellone Facile'\n\nPer i casi piu' urgenti durante un torneo, WhatsApp e' il canale piu' veloce (rispondiamo in pochi minuti).",
    options: [
      { label: "Scrivi una email", navigate: "mailto:info@tabellonefacile.net", end: true },
      { label: "Apri WhatsApp", navigate: "https://wa.me/393762891321", end: true },
      { label: "Vai alla pagina Facebook", navigate: "https://www.facebook.com/profile.php?id=61575382990256", end: true },
      { label: "Torna al menu", next: "welcome" },
    ],
  },

  // ─── PRIMI PASSI (tour guidato passo-passo) ───
  first_steps: {
    bot:
      "Benvenuto! Ecco il percorso consigliato per partire bene su Tabellone Facile.\n\nIo ti farò strada in 6 tappe:\n1) Configurare il Circolo (loghi, indirizzo, recapiti)\n2) Creare il primo torneo\n3) Aggiungere categorie\n4) Inserire giocatori\n5) Generare tabellone\n6) Programmare il calendario\n\nIniziamo dalla tappa 1?",
    options: [
      { label: "Sì, parti dalla tappa 1 (Circolo)", next: "venue_setup" },
      { label: "Salta al passo 2 (Torneo)", next: "create_tournament" },
      { label: "Mostrami una panoramica veloce", next: "first_steps_overview" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  first_steps_overview: {
    bot:
      "Ecco in 30 secondi cosa puoi fare:\n\n• HOME: lista dei tuoi tornei, crea/elimina\n• TORNEO → tab DETTAGLI: date, fasce orarie, max match/giorno, tempo riposo, disponibilità campi, notifiche email\n• TORNEO → tab CATEGORIE: gestione giocatori per gara\n• TORNEO → tab TABELLONE: generazione draw (4 modalità)\n• TORNEO → tab CALENDARIO: schedulazione automatica + drag&drop\n• PROFILO → INFO CIRCOLO: dati del tuo club + loghi nei PDF\n• PROFILO → ABBONAMENTO: trial 14 giorni → piano a pagamento\n\nQuale tappa vuoi affrontare per prima?",
    options: [
      { label: "Configurare il Circolo", next: "venue_setup" },
      { label: "Creare il primo torneo", next: "create_tournament" },
      { label: "Torna ai primi passi", next: "first_steps" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },

  // ─── SETUP INFO CIRCOLO ───
  venue_setup: {
    bot:
      "Configurare il Circolo è importante perché i suoi dati e i loghi compaiono in tutti i PDF (tabellone e calendario).\n\nVai sull'icona profilo in alto a destra → INFO CIRCOLO. Cosa vuoi configurare per prima?",
    options: [
      { label: "Logo principale del Circolo", next: "venue_main_logo" },
      { label: "Loghi aggiuntivi (FITP, sponsor)", next: "venue_extra_logos" },
      { label: "Indirizzo e Recapiti", next: "venue_contacts" },
      { label: "Link Google Maps", next: "venue_maps" },
      { label: "Vai subito a Info Circolo", navigate: "/venue", end: true },
      { label: "Tappa successiva (Crea Torneo)", next: "create_tournament" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  venue_main_logo: {
    bot:
      "LOGO PRINCIPALE:\n• Nella pagina Info Circolo, prima card 'Logo del Circolo'\n• Click su 'Carica Logo' → seleziona JPG / PNG / SVG (max 5MB)\n• Per rimuoverlo: pulsante rosso ✕ in alto a destra sull'anteprima\n• Per sostituirlo: click su 'Cambia Logo'\n\nIl logo principale verrà stampato a sinistra in tutti i PDF, accanto al nome del circolo.",
    options: [
      { label: "Vai a Info Circolo", navigate: "/venue", end: true },
      { label: "Come carico i loghi aggiuntivi?", next: "venue_extra_logos" },
      { label: "Torna a Configurare il Circolo", next: "venue_setup" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  venue_extra_logos: {
    bot:
      "LOGHI AGGIUNTIVI (FITP, ATP, WTA, sponsor, comune, partner...):\n• Nella pagina Info Circolo, seconda card 'Loghi Aggiuntivi'\n• Click sull'area tratteggiata '+ Aggiungi' → seleziona immagine\n• Puoi caricarne più di uno: appariranno tutti in alto a destra dei PDF\n• Pulsante ✕ rosso per rimuoverne uno\n\nDopo l'upload ricordati di salvare in fondo alla pagina!",
    options: [
      { label: "Vai a Info Circolo", navigate: "/venue", end: true },
      { label: "Come si vedono sul PDF?", next: "venue_logos_pdf_preview" },
      { label: "Torna a Configurare il Circolo", next: "venue_setup" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  venue_logos_pdf_preview: {
    bot:
      "Nel PDF:\n• Logo principale → angolo in alto a SINISTRA, accanto al nome del circolo\n• Loghi aggiuntivi → angolo in alto a DESTRA, in fila\n• Sotto al logo principale: indirizzo, telefono, email, link Maps\n• Tra header e contenuto: linea separatoria + dicitura 'Tabellone generato secondo Regolamento FITP'\n\nSe vuoi vedere il risultato, esporta il PDF di un tabellone o calendario.",
    options: [
      { label: "Torna ai Loghi Aggiuntivi", next: "venue_extra_logos" },
      { label: "Torna a Configurare il Circolo", next: "venue_setup" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  venue_contacts: {
    bot:
      "DATI DEL CIRCOLO:\n• Nome Circolo (es. 'ASD Tennis Club Roma')\n• Indirizzo, CAP, Città, Provincia\n• Telefono, Email\n• Sito Web\n\nQuesti dati compaiono nell'header di tutti i PDF, accanto al logo principale. Sono utili per i giudici arbitri e per gli atleti che vogliono raggiungere il circolo.",
    options: [
      { label: "Vai a Info Circolo", navigate: "/venue", end: true },
      { label: "Torna a Configurare il Circolo", next: "venue_setup" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  venue_maps: {
    bot:
      "LINK GOOGLE MAPS:\n• Apri Google Maps sul tuo telefono o computer\n• Cerca il tuo Circolo\n• Click su 'Condividi' → 'Copia link'\n• Incolla nel campo 'Link Google Maps' di Info Circolo\n• Nei PDF apparirà il link cliccabile 'Indicazioni stradali'\n\nÈ molto utile per i visitatori che ricevono il PDF via email.",
    options: [
      { label: "Vai a Info Circolo", navigate: "/venue", end: true },
      { label: "Torna a Configurare il Circolo", next: "venue_setup" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },

  // ─── TORNEO ───
  create_tournament: {
    bot:
      "Perfetto! Per creare un torneo:\n• Apri la sezione Home (icona casa in alto)\n• Clicca il pulsante NUOVO TORNEO\n• Compila nome, date inizio/fine, n° campi e fasce orarie giornaliere\n\nIl torneo nasce vuoto: poi aggiungi categorie e giocatori.",
    options: [
      { label: "Vai alla Home", navigate: "/", end: true },
      { label: "Come aggiungo le categorie?", next: "add_categories" },
      { label: "Cos'è la fascia oraria?", next: "explain_slots" },
      { label: "Tappa successiva (Categorie)", next: "add_categories" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  add_categories: {
    bot:
      "Le categorie sono le 'sezioni di gara' (es. Singolare U12 Maschile). Dentro il torneo:\n• Vai sul tab CATEGORIE\n• Clicca AGGIUNGI CATEGORIA\n• Inserisci nome, durata media di un match e tipo di tabellone\n\nUn torneo può avere più categorie indipendenti.",
    options: [
      { label: "Tappa successiva (Giocatori)", next: "import_players" },
      { label: "E i giocatori come li inserisco?", next: "import_players" },
      { label: "Torna a Creare Torneo", next: "create_tournament" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  explain_slots: {
    bot:
      "Le fasce orarie sono i blocchi della giornata in cui si possono giocare i match:\n• Mattina  09:00–13:00\n• Pomeriggio  13:00–17:00\n• Sera  17:00–21:00\n\nPuoi configurare la priorità di riempimento (default: Pomeriggio → Sera → Mattina).",
    options: [
      { label: "Torna a Creare Torneo", next: "create_tournament" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },

  // ─── GIOCATORI ───
  import_players: {
    bot:
      "Hai due modi per inserire giocatori:\n1) MANUALE: in CATEGORIE → Aggiungi Giocatore\n2) BULK da EXCEL: nella sezione Dettagli Torneo, scarica il template, compila e carica\n\nIl template Excel ha 9 colonne: Categoria, Cognome/Nome, Sesso, Cat. Età, Ranking, Circolo, Email, Telefono, Preferenze Orario.",
    options: [
      { label: "Scarica il template Excel ora", navigate: "/", end: true },
      { label: "Cosa scrivo nel Ranking?", next: "explain_ranking" },
      { label: "Tappa successiva (Tabellone)", next: "generate_bracket" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  explain_ranking: {
    bot:
      "Il Ranking è il livello FITP della giocatrice/giocatore. Valori validi:\n• 1.1 → 1.6 (top)\n• 2.1 → 2.8\n• 3.1 → 3.6\n• 4.1 → 4.6\n• 4.NC (non classificati)\n\nIl ranking determina ordinamento, seeding e suddivisione in sezioni.",
    options: [
      { label: "Torna a Importa Giocatori", next: "import_players" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },

  // ─── TABELLONE ───
  generate_bracket: {
    bot:
      "Per generare un tabellone vai su CATEGORIE → seleziona la categoria → tab Tabellone. Hai 4 modalità:\n\n• CREA VUOTO: solo slot, riempi tu manualmente\n• CASUALE: distribuisce i giocatori a caso\n• CON TDS: tu scegli le teste di serie + dove vanno i qualificati\n• PER RANKING: divide automaticamente in sezioni (4.NC, 4.x, 3.x...)\n\nQuale vuoi approfondire?",
    options: [
      { label: "Modalità Con TdS", next: "explain_with_tds" },
      { label: "Modalità Per Ranking", next: "explain_per_ranking" },
      { label: "Cos'è il favore di pronostico?", next: "faq_pronostico" },
      { label: "Cos'è il N° Qualificati?", next: "explain_qualifiers" },
      { label: "Tappa successiva (Calendario)", next: "schedule_matches" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  explain_with_tds: {
    bot:
      "Modalità CON TDS:\n• Vai sul tab Tabellone → click CON TDS\n• Per ogni sezione scegli le TdS manualmente con le frecce su/giù\n• Imposta il N° Qualificati per sezione\n• Click GENERA TABELLONE\n\nLe TdS verranno piazzate nelle posizioni geometriche standard FITP (S1 in alto, S2 in basso, S3-S4 in metà opposta...).",
    options: [
      { label: "Torna a Tabellone", next: "generate_bracket" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  explain_per_ranking: {
    bot:
      "Modalità PER RANKING (FITP):\n• Vai sul tab Tabellone → click PER RANKING\n• L'algoritmo divide automaticamente i giocatori per fascia di ranking (4.NC, 4.x, 3.x, 2.x, 1.x)\n• Ogni sezione produce N qualificati che entrano nella sezione superiore\n• Configurabile il numero di qualificati per sezione\n\nÈ la modalità più conforme al Regolamento FITP per tornei multi-fascia.",
    options: [
      { label: "Torna a Tabellone", next: "generate_bracket" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  explain_qualifiers: {
    bot:
      "I QUALIFICATI sono giocatori che da una sezione di ranking inferiore avanzano a quella superiore.\n\nEsempio: 2 qualificati 4.NC → giocheranno la sezione 4.x.\n\nImpostalo dal dialog 'Per Ranking' o 'Con TdS' per ogni sezione (consigliato: 1-2 per sezione, max 4).",
    options: [
      { label: "Torna a Tabellone", next: "generate_bracket" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },

  // ─── CALENDARIO ───
  schedule_matches: {
    bot:
      "Per programmare gli incontri:\n• Vai sul tab CALENDARIO\n• Click GENERA CALENDARIO\n\nL'algoritmo distribuisce i match rispettando:\n• Max incontri/giorno per giocatore\n• Tempo di riposo minimo tra partite\n• Disponibilità campi (per giorno)\n• Priorità delle fasce orarie\n\nPuoi poi spostare singole partite con drag-and-drop o modificarle.",
    options: [
      { label: "Cos'è il tempo di riposo?", next: "explain_rest" },
      { label: "Come modifico un match?", next: "edit_match" },
      { label: "Tappa successiva (Risultati)", next: "record_results" },
      { label: "Hai finito! Esporta i PDF", next: "export_pdf" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  explain_rest: {
    bot:
      "Il TEMPO DI RIPOSO è l'intervallo minimo (in minuti) tra due partite consecutive dello stesso giocatore.\n\nEsempio: rest=30 → un match alle 10:00–11:30 → la successiva può iniziare non prima delle 12:00.\n\nIl valore default si imposta in Dettagli Torneo, ma puoi sovrascriverlo per singolo giocatore in Categorie.",
    options: [
      { label: "Torna a Calendario", next: "schedule_matches" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  edit_match: {
    bot:
      "Sul singolo match puoi:\n• DRAG&DROP per spostarlo di giorno\n• Click sulla card → dialog 'Modifica Programmazione' per cambiare data/ora/campo/durata\n• Inserire risultato (set + winner)\n\nLa durata viene calcolata automaticamente da ora inizio - ora fine.",
    options: [
      { label: "Torna a Calendario", next: "schedule_matches" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },

  // ─── RISULTATI ───
  record_results: {
    bot:
      "Per inserire un risultato:\n• Clicca sul match nel Tabellone o Calendario\n• Inserisci il punteggio (es. 6-2 6-1) e il vincitore\n• Salva\n\nIl vincitore avanza automaticamente al turno successivo. Sul PDF tabellone comparirà (W) accanto al nome con il punteggio.",
    options: [
      { label: "Torna al menu", next: "welcome" },
    ],
  },

  // ─── PDF EXPORT ───
  export_pdf: {
    bot:
      "Hai 3 PDF disponibili:\n• PDF TABELLONE → struttura ad albero con TDS, risultati e durata\n• PDF CALENDARIO → tabella con orari per giorno + punteggi e durate\n• PDF CON TUTTI I LOGHI → versione ufficiale stile FITP, con loghi sponsor/federazione\n\nTrovi i pulsanti nei rispettivi tab (Tabellone, Calendario). Puoi aggiungere NOTE in fondo a ogni pagina.",
    options: [
      { label: "Come carico i loghi sponsor?", next: "explain_extra_logos" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  explain_extra_logos: {
    bot:
      "Vai nell'area Info Circolo (icona profilo in alto a destra):\n• Carica il logo principale del circolo\n• Carica i loghi aggiuntivi (FITP, sponsor, comune, partner...)\n• I loghi compariranno automaticamente nei PDF in alto a destra\n• Salva con il pulsante in fondo alla pagina",
    options: [
      { label: "Vai a Info Circolo", navigate: "/venue", end: true },
      { label: "Torna a Export PDF", next: "export_pdf" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },

  // ─── FAQ FITP ───
  faq_fitp: {
    bot: "Cosa vuoi sapere del Regolamento FITP?",
    options: [
      { label: "Favore di pronostico", next: "faq_pronostico" },
      { label: "Posizione delle TDS nel tabellone", next: "faq_tds_position" },
      { label: "Regola dei qualificati (aspèttito)", next: "faq_aspettito" },
      { label: "Cos'è un BYE?", next: "faq_bye" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  faq_pronostico: {
    bot:
      "FAVORE DI PRONOSTICO (FITP Vol. I, racc. 5):\n• Le teste di serie devono affrontare al primo turno il giocatore più debole disponibile\n• In assenza di BYE, S1 incontra il NoN-TDS di classifica più bassa\n• In presenza di BYE, S1 ne riceve uno (avanza direttamente al secondo turno)\n\nObiettivo: evitare che i top giocatori vengano eliminati troppo presto.",
    options: [
      { label: "Torna alle FAQ FITP", next: "faq_fitp" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  faq_tds_position: {
    bot:
      "POSIZIONE TDS (tabellone D giocatori):\n• S1 in posizione 1 (in alto a sinistra)\n• S2 in posizione D (in basso a destra)\n• S3 in pos D/2 oppure D/2+1\n• S4 nell'opposta della S3\n• S5-S8 nelle 4 zone restanti (uno per quarter)\n\nCosì S1 e S2 si possono incontrare solo in finale, S3-S4 in semifinale, S5-S8 in QF.",
    options: [
      { label: "Torna alle FAQ FITP", next: "faq_fitp" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  faq_aspettito: {
    bot:
      "QUALIFICATI IN ASPÈTTITO (FITP Vol. II, pag. 7 NB):\n• Un qualificato in posizione adiacente a un BYE si dice 'in aspèttito'\n• Quando tutti i posti TDS sono occupati, i qualificati devono giocare contro le TDS di numerazione PIÙ ELEVATA (es. S5-S8), non contro S1 o S2\n• Questo protegge le top TDS da match difficili in turni iniziali\n\nTabellone Facile applica questa regola automaticamente.",
    options: [
      { label: "Torna alle FAQ FITP", next: "faq_fitp" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
  faq_bye: {
    bot:
      "BYE = 'passaggio gratuito' al turno successivo.\n• Numero BYE = D − P (dim. tabellone meno partecipanti)\n• Esempio: 10 giocatori, D=16 → 6 BYE\n• I BYE vanno prima alle TDS in ordine (S1, S2...), poi distribuiti a chi è più alto in ranking\n• MAI 2 BYE allo stesso giocatore (regola FITP)",
    options: [
      { label: "Torna alle FAQ FITP", next: "faq_fitp" },
      { label: "Torna al menu", next: "welcome" },
    ],
  },
};
